{
  "PRICING_COMMONS": {
    "STARTING_AT_LABEL": "Starting at",
    "MINIMUM_PRICE_LABEL": "Minimum",
    "FREE_LABEL": "Free",
    "CONTACT_SALES_LABEL": "Contact Sales",
    "SETUP_FEE_LABEL": "Setup fee",
    "MANAGEMENT_FEE_LABEL": "Management fee",
    "PRICE_UNAVAILABLE_LABEL": "Price unavailable",
    "VARIABLE_PRICE_INPUT": {
      "LABEL": "Enter amount",
      "ADD_NOTE": "Add note",
      "NOTE_LABEL": "Note"
    }
  },
  "SUBSIDIARY_CHANGE_WARNING": {
    "TITLE": "Re-enter your payment method",
    "WILL_REQUIRE_PAYMENT_METHOD": "Changing your billing contact's country may require you to re-enter a payment method.",
    "AVOID_TRANSACTION_DELAYS": "Ensure that you re-enter a payment method to avoid delaying future transactions.",
    "CONFIRM": "Confirm",
    "WARNING": "Warning"
  },
  "REFUND_DIALOG": {
    "TITLE": "Issue refund",
    "ORIGINAL_CHARGE": "The original charge was",
    "AMOUNT": "Refund amount",
    "REFUND_MUST_BE_GREATER_THAN_ZERO": "Refund must be greater than",
    "REFUND_CANNOT_EXCEED_AMOUNT": "Refund cannot exceed amount",
    "REASON_LABEL": "Reason",
    "REASON_LABEL_HINT": "Reason will not be visible to customer",
    "SELECT_REASON": "Select a reason",
    "REASON_REQUIRED": "Reason for refund required",
    "DETAILED_NOTES": "Detailed notes",
    "NOTES_REQUIRED": "Notes required",
    "NOTES_LABEL": "Notes",
    "NOTES_LABEL_HINT": "Notes will be visible to customer",
    "CANCEL": "Cancel",
    "CONFIRM": "Confirm"
  },
  "SUBSCRIPTIONS": {
    "FILTERS": {
      "SEARCH": "Search subscriptions",
      "FREQUENCY": {
        "ONE_TIME": "One Time",
        "MONTHLY": "Monthly",
        "YEARLY": "Yearly"
      },
      "DATE": {
        "ENDS_BEFORE": "Ends Before",
        "ENDS_AFTER": "Ends After"
      }
    },
    "EXPORT": {
      "SUCCESS": "Export started, you will receive a download notification when your file is ready",
      "ERROR": "Failed to start subscriptions export",
      "LABEL": "Export as CSV"
    }
  },
  "BILLING_CONTACT": {
    "TITLE": "Billing contact",
    "COMPANY_NAME": "Company name",
    "NAME": "Name",
    "EMAIL_ADDRESS": "Email address(es)",
    "EMAIL_DELIMITER": "Comma or semicolon separated",
    "EMAIL_REQUIRED_ERROR": "At least one email address is required",
    "EMAIL_INVALID_ERROR": "Email addresses entered must be valid: example@example.com",
    "PHONE_NUMBER": "Phone number",
    "ADDRESS": "Address",
    "COUNTRY": "Country",
    "CITY": "City",
    "PROVINCE": "State/Province",
    "POSTAL_CODE": "Zip/Postal code",
    "CANCEL": "Cancel",
    "SAVE": "Save",
    "SAVE_SUCCESS": "Successfully updated contact information.",
    "SAVE_ERROR": "Error updating contact information."
  },
  "CHARGE_INVOICE_DIALOG": {
    "TITLE": "Charge sales invoice ({{ number }})",
    "TOTAL": "Total amount:",
    "OUTSTANDING": "Outstanding balance:",
    "AMOUNT": "Amount",
    "CANCEL": "Cancel",
    "CHARGE": "Charge invoice",
    "ERROR_AMOUNT_IS_REQUIRED": "Amount is required",
    "ERROR_MINIMUM_AMOUNT": "Amount must be at least 50"
  },
  "PAYMENT_METHOD": {
    "UPDATE_SUCCESS": "Successfully updated payment method"
  }
}
